<template>
  <div class="article">
    <bread-crumb></bread-crumb>
    <div class="wrap">
      <div class="c-title-wrap">
        <p class="c-title">基本内容</p>
      </div>
      <!--药品名称-->
      <encyclopedia-name
        :encyclopediaName.sync="form.contentName"
      ></encyclopedia-name>
      <!--别名-->
      <contentAlias-Names
        :aliasName.sync="form.contentAliasNames"
      ></contentAlias-Names>
      <!-- 药品分类 -->
      <category-drugs
        ref="categoryDrugsRef"
        :functionIds="{
          queryDrugCategoryWithRel: 'health_cmp_biz_queryDrugCategoryWithRel',
        }"
        @checkCateGoryLabel="checkCateGoryLabel"
      />
      <!-- 处方药 -->
      <prescription-drugs :prescriptionDrug.sync="prescriptionDrug" />
      <!--关联药品-->
      <select-encyclopedia
        :data="form.contentDrugs"
        @changeEncyclopediaLabels="changeEncyclopediaLabels"
        :is-show-encyclopedia="isShowEncyclopedia"
        :functionIds="{
          queryEncyclopedia: 'health_cmp_biz_WriterPageDrugInfoByParam',
        }"
      >
      </select-encyclopedia>
      <!--关联疾病-->
      <encyclopedia-label
        :data="form.contentDiseases"
        @changeDiseaseLabels="changeDiseaseLabels"
        :is-show-disease="isShowDisease"
        :functionIds="{ queryContents: 'health_cmp_pageDiseaseInfoByParam' }"
      ></encyclopedia-label>
      <!--基本信息-->
      <div
        class="content-item flex"
        style="position: relative"
        v-for="(item, index) in paragraphList"
        :key="index"
      >
        <p class="content-item-label">
          <span class="red">*</span>{{ item.desc }}
        </p>
        <c-editor
          :content="item.content || ''"
          :index="index"
          @editorReady="editorReady"
          :ref="'editor' + index"
          @blurEditorEvent="blurEditorEvent"
        ></c-editor>
      </div>
      <!--编审药师-->
      <write-doctor
        :writeDoctor.sync="writeDoctor"
        :writeOptions="writeOptions"
        :write_doctor_loading="write_doctor_loading"
        @write_remoteMethod="write_remoteMethod"
        @writeChange="writeChange"
        :isFlag="true"
        :Pharmacist="1"
      ></write-doctor>
      <!--关键词-->
      <keywords :keyWordsShow="keyWordsShow" ref="keywordsref"></keywords>
    </div>
    <div class="finish-buttons">
      <el-button @click="saveOrUpdateDiseaseInfo(0, 'preview')"
        ><span>预览</span>
      </el-button>
      <el-button
        @click="saveOrUpdateDiseaseInfo(1, 'draft')"
        v-if="auditInfoShow !== 3"
        ><span>保存</span>
      </el-button>
      <el-button @click="saveOrUpdateDiseaseInfo(2, 'submit')" type="primary"
        ><span>提交</span>
      </el-button>
    </div>
    <!-- ===================== 预览弹窗 ====================== -->
    <preview-modal
      :mUrl.sync="mUrl"
      :dialogPreVisible.sync="dialogPreVisible"
      :qrCode="qrCode"
    ></preview-modal>
  </div>
</template>

<script>
import BreadCrumb from "../../../../components/breadCrumb";
import EncyclopediaName from "../../../../components/input/EncyclopediaName";
import contentAliasNames from "../../../../components/input/contentAliasNames";
import ContentLabel from "@/components/tag/ContentLabel";
import CategoryDrugs from "@/components/radio/CategoryDrugs";
import PrescriptionDrugs from "@/components/radio/PrescriptionDrugs";
import SelectEncyclopedia from "../../../../components/tag/SelectEncyclopedia";
import CEditor from "../../../../components/cEditor";
import WriteDoctor from "../../../../components/select/WriteDoctor";
import EncyclopediaLabel from "../../../../components/tag/EncyclopediaLabel";
import { request } from "@/utils/axios";
import Keywords from "../../../../components/input/Keywords";
import PreviewModal from "../../../../components/pop/PreviewModal";
import { getQRCode } from "../../../../utils/tools";
import utils from "../../../../utils";
import {
  newDrugEncyclopedia,
  modifyDrugEncyclopedia,
  queryDrugWarehouse,
} from "../../../../api/drugs";
import {
  submittedByWriter,
  getDiseaseSymptomsDraftDetails,
} from "../../../../api/symptomaticDisease";

export default {
  name: "encyclopedia",
  components: {
    EncyclopediaLabel,
    PreviewModal,
    Keywords,
    WriteDoctor,
    CEditor,
    SelectEncyclopedia,
    contentAliasNames,
    BreadCrumb,
    EncyclopediaName,
    ContentLabel,
    CategoryDrugs,
    PrescriptionDrugs,
  },
  data() {
    return {
      form: {
        tenantId: Number(this.$commonJs.getTenantId()), // 租户id
        contentName: "", // 药品名称
        contentAliasNames: [],
        aliasName: [], // 别名
        contentDiseases: [], //绑定疾病id
        contentParagraphs: [], // 段落
        keywordInfos: [], // 内容关键词
        doctorInfos: [], // 关联的医生
        contentDrugs: [], // 药品
        contentAttributes: [], // 常见药品
        contentId: undefined,
        contentLabels: [], // 标签信息
        drugCategories: [], // 药品分类
      },
      prescriptionDrug: 0, // 是否为处方药
      paragraphList: [],
      editorList: {},
      // 编写医生
      write_doctor_loading: false,
      writeOptions: [],
      doctorOptions: [],
      writeDoctor: "",
      doctor: "",
      isShowDisease: false,
      dialogPreVisible: false,
      isShowEncyclopedia: false,
      mUrl: "",
      keyWordsShow: 1,
      auditInfoShow: "",
    };
  },
  mounted() {
    this.getContentParagraphDictionary(); // 获取段落信息
    // 获取药品分类
    // 点击空白地方，文章内容存到缓存里面，当刷新页面的时候能够回显
    var flag = true;
    var isjqTri = false;
    var selectRoleSetTimeout;
    $("#selectRole")
      .on("compositionstart", function () {
        flag = false;
      })
      .on("compositionend", function () {
        flag = true;
      })
      .on("input", function (e) {
        clearTimeout(selectRoleSetTimeout);
        if (!this.loading)
          selectRoleSetTimeout = setTimeout(function () {
            if (flag && !isjqTri) {
              isjqTri = true;
            } else {
              isjqTri = false;
            }
          }, 100);
      });
    // 如果是编辑文章
    if (this.$route.query.id) {
      this.form.contentId = this.$route.query.id;
      this.getDiseaseInfoDraftDetail();
    }
    this.$refs.categoryDrugsRef.queryDrugCategoryWithRel(this.form.contentId);
  },
  destroyed() {
    // 移除段落缓存
    sessionStorage.removeItem("cache_articles");
  },
  methods: {
    editorReady(data) {
      this.editorList["editor" + data.index] = data.editor;
      this.restoreContentParagraphs(data);
    },
    blurEditorEvent(editor, index) {
      // 编辑文章不做临时保存操作
      /*if(this.form.contentId){
          return;
        }*/
      this.paragraphList[index].content = editor.getContent() || "";
      // var tipDom = $(
      //   '<div class="successfully" style="position: absolute; top: 0; right: 15px;color: green;">保存成功</div>'
      // );
      // let ParentElement = $(editor.editorContainer).find(".tox-toolbar__group").eq(0)
      // let subelement = ParentElement.find(".successfully")
      // // 只创建一次
      // if (subelement.length == 0) {
      //   $(editor.editorContainer).find(".tox-toolbar__group").eq(0).append(tipDom);
      // }
      // clearTimeout(this.tipTimeout);
      // this.tipTimeout = setTimeout(function () {
      //   var DeleteElement = $(".tox-toolbar__group .successfully:eq(0)");
      //   if (DeleteElement) {
      //     DeleteElement.remove()
      //   }
      // }, 500);

      var cacheArticle = this.$commonJs.getArticleDataFromCache(
        this.form.contentId
      );
      if (cacheArticle) {
        this.form.contentParagraphs = cacheArticle.contentParagraphs;
      } else {
        // 如果不存在，则新增一篇文章
        this.paragraphList.forEach((item) => {
          this.form.contentParagraphs.push({
            paragraphCode: item.code,
            paragraphName: item.desc,
            paragraphType: item.type,
            paragraphContent: item.content || "",
          });
        });
      }
      this.form.contentParagraphs[index].paragraphContent =
        editor.getContent() || "";
      this.$commonJs.setCacheArticleData(this.$commonJs.deepClone(this.form));
    },
    // 恢复段落内容
    restoreContentParagraphs({ editor, index }) {
      var article = this.$commonJs.getArticleDataFromCache(this.form.contentId);
      if (!article) {
        return;
      }
      this.$set(
        this.paragraphList[index],
        "content",
        article.contentParagraphs[index].paragraphContent
      );
    },
    // 编写医生
    write_remoteMethod(query) {
      this.doctorList(query, "writeOptions", "write_doctor_loading");
    },
    writeChange() {
      if (this.writeDoctor == "") {
        this.writeOptions = [];
      }
    },
    doctorList(query, str, loadingStr) {
      if (query !== "") {
        this[loadingStr] = true;
        request("health_cmp_listByDoctorName", {
          tenantId: this.$commonJs.getTenantId(),
          doctorName: query,
        })
          .then((res) => {
            this[str] = res;
            this[loadingStr] = false;
          })
          .catch((err) => {
            this[str] = [];
            this[loadingStr] = false;
          });
      } else {
        this[str] = [];
      }
    },
    // 获取疾病信息
    changeDiseaseLabels(data) {
      // 关联疾病
      this.form.contentDiseases = data;
    },
    // 获取药品信息
    changeEncyclopediaLabels(data) {
      this.form.contentDrugs = data;
    },
    //获取段落信息
    getContentParagraphDictionary() {
      request("health_cmp_getContentParagraphDictionary", {
        type: 7,
      })
        .then((res) => {
          this.paragraphList = res || [];
        })
        .catch((err) => {});
    },
    // 预览
    preview() {
      this.dialogPreVisible = true;
      this.previewDialog = true;
      let newUrl = process.env.VUE_APP_PREVIEWURL;
      this.mUrl = newUrl;
      getQRCode(newUrl, (url) => {
        this.qrCode = url;
        this.dialogPreVisible = true;
      });
    },
    // 校验
    checkBeforeAddOrUpdate(val, opt_type) {
      if (!this.form.contentName || this.form.contentName.trim() == "") {
        this.$message.error("药品名称不能为空");
        return false;
      }
      if (!this.form.drugCategories || this.form.drugCategories.length == 0) {
        this.$message.error("药品分类不能为空");
        return false;
      }
      if (val == 1 || val == 0) return true; // 若为保存、预览只校验名称
      let isParagraphsPass = true;
      let paragraphsText = [];
      isParagraphsPass = this.form.contentParagraphs.some((item) => {
        paragraphsText.push(item.paragraphName);
        return item.paragraphContent != "";
      });
      if (!isParagraphsPass) {
        this.$message.error(paragraphsText.join(",") + "至少填写一项");
        return false;
      }
      return true;
    },
    initFormBeforeAddOrUpdate(val, opt_type) {
      this.form.contentName = this.form.contentName.trim();
      this.form.contentParagraphs = [];
      this.paragraphList.map((item, index) => {
        this.form.contentParagraphs.push({
          paragraphCode: item.code,
          paragraphName: item.desc,
          paragraphType: item.type,
          paragraphContent:
            this.editorList["editor" + index].getContent() || "",
        });
      });
      if (this.$refs.keywordsref.keywordInfos.length) {
        let arr = [];
        this.$refs.keywordsref.keywordInfos.map((item) => {
          arr.push({
            keyword: item,
            keywordType: "1",
          });
        });
        this.form.keywordInfos = arr;
      } else {
        this.form.keywordInfos = [];
      }
      this.form.contentAttributes = [];
      this.form.contentAttributes.push({
        type: 9,
        code: Number(this.prescriptionDrug),
      });
      // 编写医生
      this.form.doctorInfos = [];
      this.writeOptions.map((item) => {
        if (this.writeDoctor == item.docId) {
          item.roleType = 2;
          this.form.doctorInfos.push(item);
        }
      });
      this.doctorOptions.map((item) => {
        if (this.doctor == item.docId) {
          item.roleType = 1;
          this.form.doctorInfos.push(item);
        }
      });
    },
    // 获取文章详情
    getDiseaseInfoDraftDetail() {
      getDiseaseSymptomsDraftDetails({
        contentId: this.$route.query.id,
        tenantId: this.$commonJs.getTenantId(),
      }).then((res) => {
        // 检查缓存更新时间和最新更新时间确定是否删除缓存
        var cacheArticle = this.$commonJs.getArticleDataFromCache(
          res.contentId
        );
        if (cacheArticle) {
          try {
            var cacheUpdate = new Date(
              cacheArticle.updateTime.replace(/-/g, "/")
            );
            var lastUpdate = new Date(res.updateTime.replace(/-/g, "/"));
            if (lastUpdate.getTime() > cacheUpdate.getTime()) {
              this.$commonJs.removeCacheArticleData(res.contentId);
            }
          } catch (error) {
            console.log(error);
          }
        }
        this.displayInfo(res);
      });
    },
    filterContentAttrbutes(arr, type) {
      const filterArr = arr.filter((item) => item.type == type);
      return filterArr.length > 0 ? filterArr[0] : {};
    },
    displayInfo(res) {
      if (res.auditInfo) {
        this.auditInfoShow = res.auditInfo.auditStatus;
      }
      //反显药品名称
      if (res.contentName) {
        this.form.contentName = res.contentName;
      }
      if (res.contentDrugs) {
        this.form.contentDrugs = res.contentDrugs;
      }
      //反显别名
      if (res.contentAliasNames) {
        this.form.contentAliasNames = res.contentAliasNames;
      }
      //反显关联疾病
      this.form.contentDiseases = res.contentDiseases || [];
      //反显段落
      this.form.contentParagraphs = res.contentParagraphs || [];
      this.form.drugCategories = res.drugCategories || [];
      //反显处方药
      if (res.contentAttributes) {
        // 反显处方药 单选 type为9
        this.prescriptionDrug =
          this.filterContentAttrbutes(res.contentAttributes, 9).code || 0;
      }
      var cache_article = this.$commonJs.getArticleDataFromCache(res.contentId);
      if (!cache_article) {
        var isFirstAdd = this.paragraphList.length == 0;
        res.contentParagraphs &&
          res.contentParagraphs.map((item, index) => {
            if (isFirstAdd) {
              this.paragraphList.push({
                code: item.paragraphCode,
                desc: item.paragraphName,
                type: item.paragraphType,
                content: item.paragraphContent || "",
              });
            } else {
              for (var i = 0; i < this.paragraphList.length; i++) {
                if (this.paragraphList[i].code == item.paragraphCode) {
                  this.paragraphList[i].content == item.paragraphContent || "";
                  break;
                }
              }
            }
            try {
              var isEditorInited = setInterval(() => {
                var edd = this.editorList["editor" + index];
                if (edd) {
                  clearInterval(isEditorInited);
                  edd.setContent(item.paragraphContent || "");
                }
              }, 100);
            } catch (error) {
              console.log(error);
            }
          });
      }
      this.writeOptions = [];
      this.doctorOptions = [];
      if (res.doctorInfos) {
        res.doctorInfos.map((item) => {
          if (item.roleType == 2) {
            this.writeOptions.push(item);
            this.writeDoctor = item.docId;
          }
          if (item.roleType == 1) {
            this.doctorOptions.push(item);
            this.doctor = item.docId;
          }
        });
      }
      this.form.contentAttributes = [];
      if (res.contentAttributes) {
        this.form.contentAttributes = res.contentAttributes;
      }
      //反显关键字
      this.$refs.keywordsref.keywordInfos = [];
      res.keywordInfos &&
        res.keywordInfos.map((item, index) => {
          this.$refs.keywordsref.keywordInfos.push(item.keyword);
        });
    },
    // 保存、提交
    saveOrUpdateDiseaseInfo(val, type) {
      this.initFormBeforeAddOrUpdate(val, type);
      if (!this.checkBeforeAddOrUpdate(val, type)) {
        return;
      }
      if (!utils.copyPictureCheck(this.form.contentParagraphs, this)) return; // 校验富文本编辑器不能有粘贴图片
      let params = this.$commonJs.deepClone(this.form);
      params.contentType = 13;
      let submit = this.form.contentId
        ? modifyDrugEncyclopedia
        : newDrugEncyclopedia;
      submit(params)
        .then((res) => {
          if (res) {
            if (!this.form.contentId) {
              this.form.contentId = res.contentId;
            }
            // 预览
            if (type == "preview") {
              this.articlePreview(res.contentId);
            }
            if (type == "draft") {
              this.$message.success("保存成功");
            } else if (type == "submit") {
              submittedByWriter({
                contentId: res.contentId,
                tenantId: this.$commonJs.getTenantId(),
              })
                .then((res) => {
                  if (res) {
                    this.$message.success("提交成功");
                    this.$router.push(`/manageBK`);
                  }
                })
                .catch((err) => {
                  this.$message.error(err.msg + "发布失败");
                });
            }
          }
        })
        .catch((error) => {
          this.$message.error(error.msg || "操作失败！");
        });
    },
    // 预览
    articlePreview(val) {
      this.dialogPreVisible = true;
      this.previewDialog = true;
      this.jumpUrl("/drugs", "/preview/", val);
    },
    jumpUrl(url, type, urlId) {
      let urlAddress = "//beta-api.m.jd.com";
      let previewUrl1 = "https://cont-yf.healthjd.com/wiki"; // 疾病症状预发地址
      let diseaseOnline = "https://cont.healthjd.com/wiki"; // 线上疾病
      let newUrl;
      if (process.env.VUE_APP_BASEURL == urlAddress) {
        newUrl = previewUrl1 + url + type + urlId;
      } else {
        newUrl = diseaseOnline + url + type + urlId;
      }
      this.mUrl = newUrl;
      getQRCode(newUrl, (url) => {
        this.qrCode = url;
        this.dialogPreVisible = true;
      });
    },
    checkCateGoryLabel(categoryDrugs, index) {
      //判断是否存在当前项，如果存在则取消选中并从数据中删除
      this.form.drugCategories = [];
      let obj = {
        sort: categoryDrugs[index].sort,
        id: categoryDrugs[index].id,
        name: categoryDrugs[index].name,
      };
      this.form.drugCategories.push(obj);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/styles/article_common.scss";

.article {
  @include article_common;

  .item-video-wrap {
    border: 1px solid #c0c4cc;
  }

  :deep(.el-form-item) {
    margin-bottom: 22px;
  }

  :deep(.el-textarea__inner) {
    resize: none;
    overflow: hidden;
    overflow-y: auto;
    display: inline-block;
    margin-bottom: 45px;
    margin-right: 15px;
  }

  :deep(.el-dialog__body) {
    padding: 30px 26px 0px 26px !important;
  }

  .el-button {
    line-height: 10px;
  }

  .article_tit {
    .el-input__suffix {
      left: 100% !important;
      right: auto !important;
    }
  }
}

.finish-buttons {
  position: fixed;
  text-align: center;
  width: 86%;
  background-color: #ffffff;
  bottom: 0;
  z-index: 9;
}

.article .wrap .writeDoc .el-input {
  width: 645px !important;
}
</style>
